export var CheckboxTheme;
(function (CheckboxTheme) {
    CheckboxTheme["Default"] = "default";
    CheckboxTheme["Box"] = "box";
})(CheckboxTheme || (CheckboxTheme = {}));
export var CheckboxVerticalAlignment;
(function (CheckboxVerticalAlignment) {
    CheckboxVerticalAlignment["Center"] = "center";
    CheckboxVerticalAlignment["Top"] = "top";
})(CheckboxVerticalAlignment || (CheckboxVerticalAlignment = {}));
export var CheckmarkStyle;
(function (CheckmarkStyle) {
    CheckmarkStyle["Regular"] = "regular";
    CheckmarkStyle["Medium"] = "medium";
    CheckmarkStyle["Bold"] = "bold";
})(CheckmarkStyle || (CheckmarkStyle = {}));
export var CheckboxDataHooks;
(function (CheckboxDataHooks) {
    CheckboxDataHooks["CheckboxWrapper"] = "checkbox-wrapper";
    CheckboxDataHooks["IconWrapper"] = "icon-wrapper";
    CheckboxDataHooks["LabelWrapper"] = "label-wrapper";
    CheckboxDataHooks["CheckboxCore"] = "checkbox-core";
    CheckboxDataHooks["ErrorIcon"] = "error-icon";
})(CheckboxDataHooks || (CheckboxDataHooks = {}));
export var CheckboxDataKeys;
(function (CheckboxDataKeys) {
    CheckboxDataKeys["Error"] = "data-error";
    CheckboxDataKeys["Disabled"] = "data-disabled";
    CheckboxDataKeys["Checked"] = "data-checked";
    CheckboxDataKeys["Indeterminate"] = "data-indeterminate";
    CheckboxDataKeys["Focused"] = "data-focused";
})(CheckboxDataKeys || (CheckboxDataKeys = {}));
//# sourceMappingURL=types.js.map